module.exports = __webpack_public_path__ + "static/img/paypal.282e6aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/paypal.png
// module id = UkDI
// module chunks = 1